import { Switch } from 'components/Switch'
import { useToggleFilteringRule } from 'features/globalSetup/pages/Prebid/Protection/pages/hooks/useToggleFilteringRule'
import { useAbility } from 'providers/casl'

import type { FilteringRuleForTable } from '../../hooks/useGetFilteringRules/types'
import type { CellContext } from '@tanstack/react-table'

export const EnabledCell = ({
  getValue,
  row: {
    original: { id, name },
  },
}: CellContext<FilteringRuleForTable, unknown>): React.JSX.Element => {
  const ability = useAbility()
  const canEdit: boolean = ability.can('update', 'GlobalSetupFeature-protection')

  const { checked, update } = useToggleFilteringRule({
    enabled: Boolean(getValue()),
    id,
    name,
  })

  return (
    <Switch
      checked={checked}
      disabled={!canEdit}
      onChange={update}
    />
  )
}
